import { i18n } from '../utils/setupTranslations';
import { FormKeys } from '../types';

const toTranslate: string[] = [FormKeys.PackGenre, FormKeys.PackSubgenre];

function isFile(content: string | number | File): content is File {
    return (content as File).lastModified !== undefined;
}

export default function prepareContent(
    key: string,
    _content: string | number | File,
): string | number {
    let content: string | number;

    if (toTranslate.includes(key) && typeof _content === 'string') {
        content = i18n._(_content);
    } else if (isFile(_content)) {
        content = _content.name;
    } else {
        content = _content;
    }

    return content;
}
